import { RouteProps } from 'react-router-dom';
import { MixPanelEventTypes, PlatformTypes } from './services/MixPanel';

export enum PLACEMENT {
  NONE = 0,
  DROPDOWN = 1,
  NAVBAR = 2,
}

interface MixPanelEventData {
  Selection?: string;
}

export interface MixPanelEventProps {
  name: string;
  data: MixPanelEventData;
}

export interface MixPanelLogClickProps {
  platform: PlatformTypes;
  moduleName: string;
  eventType: MixPanelEventTypes;
  pageName: string;
  selection: string;
}
export interface Link extends RouteProps {
  placement: PLACEMENT;
  label?: string;
  claim: string;
  to?: string;
  hideFooter?: boolean;
  featureToggle?: {
    name: string;
    type: string;
    treatmentValue?: string;
  };
  noMainPadding?: boolean;
  tour?: string;
  mixPanelLogClick?: MixPanelLogClickProps | undefined;
  mixPanelEvent?: MixPanelEventProps;
}

export type User = {
  token: string;
  currentUserId: number;
  currentUserFirstName: string;
  currentUserLastName: string;
  role: string | null;
  roleLevel: number | null;
  limited: boolean | null;
  isSuperRole: boolean;
  isAdminRole: boolean;
  isTherapistRole: boolean;
  organization: number | null;
  isMasquaraded: boolean;
  authErrorMessage: string;
  requirePasswordChange: boolean | null;
};

export type Platform = 'Wellness' | 'Therapy' | 'Care' | 'Insights' | 'Home';
